import React from "react";
import { getInitials } from "../../../util/helpers";

export const ChatAvatar = ({ name, url = "" }) => {
  name = getInitials(name);
  if (url === "") {
    url = `https://placehold.co/50x150/f1f1f5/395E9D/?text=${name}`;
  }
  return (
    <div
      className="d-flex justify-content-center m-2"
      style={{
        borderRadius: "100%",
        padding: "20px 30px",
        background: `url(${url}) 50%/50% no-repeat #f1f1f5`,
      }}
    />
  );
};
